import axiosInstance from '../../axios-config';

const treatmentSummaryApi = '/api/patients/{0}/treatmentSummary';
const countUnseenTreatmentSummaryItemsApi = '/api/patients/{0}/treatmentSummary/UnseenCount';

export const getPatientTreatmentSummaryItems = (patientId) =>
  axiosInstance.get(treatmentSummaryApi.replace('{0}', patientId));

export const getCountUnseenTreatmentSummaryItems = (patientId) =>
  axiosInstance.get(countUnseenTreatmentSummaryItemsApi.replace('{0}', patientId));
